<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>
        Laporan Pembelian {{ status != "semua" ? status.toUpperCase() : "" }}
      </h2>

      <br />

      <div class="filter">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill" @click="loadData">
            Filter
          </button>
        </div>
        <div></div>
        <div class="form-group">
          <label>Export Data</label>
          <button
            type="button"
            class="btn-outline green"
            @click="exportExcel()"
          >
            {{ loadingExcel ? "Loading..." : "Export Excel" }}
          </button>
        </div>
      </div>

      <div class="toggle-wrapper">
        <label class="toggle">
          <input type="checkbox" v-model="tampilanDetail" />
          <span class="labels" data-on="Detail" data-off="Summary"></span>
        </label>
      </div>

      <table class="table" v-show="tampilanDetail">
        <thead>
          <tr>
            <th>No</th>
            <th>No PO</th>
            <th>Supplier</th>
            <th>Tanggal</th>
            <th>Barang</th>
            <th>Harga</th>
            <th style="text-align: right">Jumlah Dibeli</th>
            <th style="text-align: right">Total</th>
            <th style="text-align: right">Jumlah Dibayar</th>
            <th style="text-align: right">Hutang</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in dataDetail" :key="index">
            <td
              v-if="item.separator"
              colspan="10"
              :class="item.separator ? 'separator' : ''"
            >
              &nbsp;
            </td>

            <td v-if="!item.separator">{{ ++index }}</td>
            <td v-if="!item.separator">{{ item.master.no_po }}</td>
            <td v-if="!item.separator">{{ item.master.supplier }}</td>
            <td v-if="!item.separator">
              {{ moment(item.master.tanggal).format("DD/MM/YYYY") }}
            </td>
            <td v-if="!item.separator">{{ item.nama }}</td>
            <td v-if="!item.separator">
              {{ item.harga | number }} / {{ item.per | number }}
              {{ item.satuan }}
            </td>
            <td v-if="!item.separator" align="right">
              {{ item.jumlah }} {{ item.satuan }}
            </td>
            <td v-if="!item.separator" align="right">
              {{ (parseFloat(item.jumlah) * parseFloat(item.harga)) | number }}
            </td>
            <td v-if="!item.separator" align="right">
              {{ item.dibayar | number }}
            </td>
            <td v-if="!item.separator" align="right">
              {{ item.hutang | number }}
            </td>
          </tr>
          <tr>
            <td colspan="7">
              <b>TOTAL</b>
            </td>
            <td align="right">
              <b>{{ total.total | number }}</b>
            </td>
            <td align="right">
              <b>{{ total.dibayar | number }}</b>
            </td>
            <td align="right">
              <b>{{ total.hutang | number }}</b>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table" v-show="!tampilanDetail">
        <thead>
          <tr>
            <th>No</th>
            <th>No PO</th>
            <th>Supplier</th>
            <th>Tanggal</th>
            <th style="text-align: right">Grand Total</th>
            <th style="text-align: right">Jumlah Dibayar</th>
            <th style="text-align: right">Hutang</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ ++index }}</td>
            <td>{{ item.no_po }}</td>
            <td>{{ item.supplier }}</td>
            <td>{{ moment(item.tanggal).format("DD/MM/YYYY") }}</td>
            <td align="right">{{ item.total | number }}</td>
            <td align="right">{{ item.total_bayar | number }}</td>
            <td align="right">
              {{ (parseInt(item.total) - parseInt(item.total_bayar)) | number }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b>TOTAL</b>
            </td>
            <td align="right">
              <b>{{ total.total | number }}</b>
            </td>
            <td align="right">
              <b>{{ total.dibayar | number }}</b>
            </td>
            <td align="right">
              <b>{{ total.hutang | number }}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

import * as api from "./../../api/Api";

export default {
  name: "LaporanPembelian",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      data: [],
      dataDetail: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-D"),
      },
      total: {
        total: 0,
        dibayar: 0,
        hutang: 0,
      },
      status: "",
      tampilanDetail: "",
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;
      this.status = this.$route.params.status;

      let url =
        "/v4/pembelian?id_toko=" +
        this.$toko.id +
        "&tgl_awal=" +
        this.filter.tgl_awal +
        "&tgl_akhir=" +
        this.filter.tgl_akhir;
      if (this.status == "hutang") {
        url = "/v4/pembelian?id_toko=" + this.$toko.id;
      }

      api
        .get(url)
        .then((r) => {
          this.loading = false;

          const data = [];
          const dataDetail = [];
          this.total = {
            total: 0,
            dibayar: 0,
            hutang: 0,
          };

          r.data.forEach((item) => {
            if (this.status == "lunas") {
              const hutang = parseInt(item.total) - parseInt(item.total_bayar);

              if (hutang <= 0) {
                data.push(item);
                this.total.total += parseInt(item.total);
                this.total.dibayar += parseInt(item.total_bayar);
                this.total.hutang += hutang;

                // DETAIL
                item.detail.forEach((detail, index) => {
                  detail.master = item;
                  if (index == 0) {
                    const hutang =
                      parseInt(item.total) - parseInt(item.total_bayar);

                    detail.dibayar = item.total_bayar;
                    detail.hutang = hutang;
                  } else {
                    detail.dibayar = 0;
                    detail.hutang = 0;
                  }

                  dataDetail.push(detail);

                  if (index == item.detail.length - 1) {
                    dataDetail.push({
                      separator: true,
                    });
                  }
                });
              }
            } else if (this.status == "hutang") {
              const hutang = parseInt(item.total) - parseInt(item.total_bayar);

              if (hutang > 0) {
                data.push(item);
                this.total.total += parseInt(item.total);
                this.total.dibayar += parseInt(item.total_bayar);
                this.total.hutang += hutang;

                // DETAIL
                item.detail.forEach((detail, index) => {
                  detail.master = item;
                  if (index == 0) {
                    const hutang =
                      parseInt(item.total) - parseInt(item.total_bayar);

                    detail.dibayar = item.total_bayar;
                    detail.hutang = hutang;
                  } else {
                    detail.dibayar = 0;
                    detail.hutang = 0;
                  }

                  dataDetail.push(detail);

                  if (index == item.detail.length - 1) {
                    dataDetail.push({
                      separator: true,
                    });
                  }
                });
              }
            } else {
              data.push(item);

              this.total.total += parseInt(item.total);
              this.total.dibayar += parseInt(item.total_bayar);
              this.total.hutang +=
                parseInt(item.total) - parseInt(item.total_bayar);

              // DETAIL
              item.detail.forEach((detail, index) => {
                detail.master = item;
                if (index == 0) {
                  const hutang =
                    parseInt(item.total) - parseInt(item.total_bayar);

                  detail.dibayar = item.total_bayar;
                  detail.hutang = hutang;
                } else {
                  detail.dibayar = 0;
                  detail.hutang = 0;
                }

                dataDetail.push(detail);

                if (index == item.detail.length - 1) {
                  dataDetail.push({
                    separator: true,
                  });
                }
              });
            }
          });

          this.data = data;
          this.dataDetail = dataDetail;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data. Silakan coba lagi");
        });
    },
    exportExcel() {
      this.loadingExcel = true;
      const payload = [];

      this.dataDetail.forEach((item) => {
        if (item.master) {
          payload.push({
            no_po: item.master.no_po,
            supplier: item.master.supplier,
            tanggal: item.master.tanggal,
            barang: item.nama,
            harga: item.harga,
            per: item.per,
            satuan: item.satuan,
            jumlah: item.jumlah,
            total: parseFloat(item.jumlah) * parseFloat(item.harga),
            dibayar: item.dibayar,
            hutang: item.hutang,
          });
        }
      });

      const tgl_awal = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      const tgl_akhir = moment(this.dateRange.endDate).format("YYYY-MM-DD");

      const status = this.status.toUpperCase();

      api
        .postJson(
          "https://app.restoku.id/exporter/pembelian?id_toko=" +
            this.$toko.id +
            "&title=Laporan Pembelian (" +
            status +
            ")" +
            "&tgl_awal=" +
            tgl_awal +
            "&tgl_akhir=" +
            tgl_akhir,
          payload
        )
        .then((r) => {
          if (r.valid) {
            location.href = r.url;
          }

          this.loadingExcel = false;
        })
        .catch((e) => {
          this.$toast("Terjadi kesalahan");
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    $route(to) {
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: 240px 150px 1fr 150px;
    grid-column-gap: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }

  .table {
    td {
      border-bottom: 0 !important;
      &.separator {
        border-top: 1px solid #ccc !important;
      }
    }
  }

  .toggle-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/Pembelian.vue